import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import {Select, TextField} from "@mui/material";
import {SelectOptions} from "../../constants/AppConstants";


interface Props {
    readonly options: SelectOptions[],
    readonly label?: string
    readonly onValueChange: (value: string) => void
    readonly [key: string]: any
}

export function AppAutoComplete({options,label,onValueChange, ...props}: Props) {
    const [value, setValue] = React.useState<SelectOptions>({label: "", value: ""});
    const [inputValue, setInputValue] = React.useState('');

    return (
            <Autocomplete
                {...props}
                value={value}
                onChange={(event, newValue) => {
                    if (newValue) {
                        setValue(newValue as SelectOptions);
                        //@ts-ignore
                        onValueChange(newValue.value)
                    }
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                id="controllable-states-demo"
                options={options}
                renderInput={(params) => <TextField {...params} label={label} />}
            />
        );
}

